<common-ui-components-page-layout
  [stickyHeader]="true"
  [title]="'کارت‌های ذخیره شده'"
  [hasBackAction]="true"
  [showBorder]="false"
>
  <common-ui-components-tab-group [tabs]="tabs"> </common-ui-components-tab-group>
</common-ui-components-page-layout>
